/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnknownInputs */

const en_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const fr_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const de_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const it_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconosciuto`)
};

const ru_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный`)
};

const es_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const zh_cn2_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const ja_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const hi_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात`)
};

const pt_pt2_unknown = /** @type {(inputs: UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconhecido`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const unknown = /** @type {((inputs?: UnknownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnknownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_unknown(inputs)
	if (locale === "de") return de_unknown(inputs)
	if (locale === "it") return it_unknown(inputs)
	if (locale === "ru") return ru_unknown(inputs)
	if (locale === "es") return es_unknown(inputs)
	if (locale === "zh-CN") return zh_cn2_unknown(inputs)
	if (locale === "ja") return ja_unknown(inputs)
	if (locale === "hi") return hi_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_unknown(inputs)
	return en_unknown(inputs)
});